import type { PensionAsset } from "~/types/assets.types";

export const calculateTotalMonthlyDeposit = (userProduct: PensionAsset) => {
  const monthlyDepositEmployed = userProduct?.monthlyDepositEmployee || 0;
  const monthlyDepositEmployer = userProduct?.monthlyDepositEmployer || 0;

  return Number(monthlyDepositEmployed) + Number(monthlyDepositEmployer);
};
